import React from 'react';

const Quote = () => (
  <main className="quote-main">
    <p className="quote">
      Without mathematics, there’s nothing you can do. Everything around you is mathematics.
      Everything around you is numbers.
      <b>— Shakuntala Devi, Indian writer and mental calculator</b>
    </p>
  </main>
);

export default Quote;
